/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Plan_Starter_AudienceInputs */



/**
* | output |
* | --- |
* | "For solo freelancers" |
*
* @param {Signup_Plan_Starter_AudienceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_plan_starter_audience = /** @type {((inputs?: Signup_Plan_Starter_AudienceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Plan_Starter_AudienceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("For solo freelancers")
	if (locale === "de") return /** @type {LocalizedString} */ ("For solo freelancers")
	if (locale === "it") return /** @type {LocalizedString} */ ("For solo freelancers")
	if (locale === "ru") return /** @type {LocalizedString} */ ("For solo freelancers")
	if (locale === "es") return /** @type {LocalizedString} */ ("For solo freelancers")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("For solo freelancers")
	if (locale === "ja") return /** @type {LocalizedString} */ ("For solo freelancers")
	if (locale === "hi") return /** @type {LocalizedString} */ ("For solo freelancers")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("For solo freelancers")
	return /** @type {LocalizedString} */ ("For solo freelancers")
});